module.exports = __webpack_public_path__ + "static/media/adv-5.dc3cb0b4.png";